// extracted by mini-css-extract-plugin
export default {"internal-error":"internal-error-hjpIe","page-body":"page-body-cQHeE"};